/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdjacentNewsDto } from '../models/adjacent-news-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { newsControllerCreateV1 } from '../fn/news/news-controller-create-v-1';
import { NewsControllerCreateV1$Params } from '../fn/news/news-controller-create-v-1';
import { newsControllerDeleteV1 } from '../fn/news/news-controller-delete-v-1';
import { NewsControllerDeleteV1$Params } from '../fn/news/news-controller-delete-v-1';
import { newsControllerFindAdjacentV1 } from '../fn/news/news-controller-find-adjacent-v-1';
import { NewsControllerFindAdjacentV1$Params } from '../fn/news/news-controller-find-adjacent-v-1';
import { newsControllerFindAllV1 } from '../fn/news/news-controller-find-all-v-1';
import { NewsControllerFindAllV1$Params } from '../fn/news/news-controller-find-all-v-1';
import { newsControllerFindByIdV1 } from '../fn/news/news-controller-find-by-id-v-1';
import { NewsControllerFindByIdV1$Params } from '../fn/news/news-controller-find-by-id-v-1';
import { newsControllerSearchCursorV1 } from '../fn/news/news-controller-search-cursor-v-1';
import { NewsControllerSearchCursorV1$Params } from '../fn/news/news-controller-search-cursor-v-1';
import { newsControllerSearchV1 } from '../fn/news/news-controller-search-v-1';
import { NewsControllerSearchV1$Params } from '../fn/news/news-controller-search-v-1';
import { newsControllerToggleExposedV1 } from '../fn/news/news-controller-toggle-exposed-v-1';
import { NewsControllerToggleExposedV1$Params } from '../fn/news/news-controller-toggle-exposed-v-1';
import { newsControllerUpdateV1 } from '../fn/news/news-controller-update-v-1';
import { NewsControllerUpdateV1$Params } from '../fn/news/news-controller-update-v-1';
import { NewsDto } from '../models/news-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class NewsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `newsControllerSearchV1()` */
  static readonly NewsControllerSearchV1Path = '/api/v1/news/search';

  /**
   * News 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerSearchV1$Response(params?: NewsControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<NewsDto>;
}>> {
    return newsControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * News 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerSearchV1(params?: NewsControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<NewsDto>;
}> {
    return this.newsControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<NewsDto>;
}>): OffsetPaginationDto & {
'items'?: Array<NewsDto>;
} => r.body)
    );
  }

  /** Path part for operation `newsControllerSearchCursorV1()` */
  static readonly NewsControllerSearchCursorV1Path = '/api/v1/news/search/cursor';

  /**
   * News 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerSearchCursorV1$Response(params?: NewsControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<NewsDto>;
}>> {
    return newsControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * News 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerSearchCursorV1(params?: NewsControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<NewsDto>;
}> {
    return this.newsControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<NewsDto>;
}>): CursorPaginationDto & {
'items'?: Array<NewsDto>;
} => r.body)
    );
  }

  /** Path part for operation `newsControllerFindAllV1()` */
  static readonly NewsControllerFindAllV1Path = '/api/v1/news';

  /**
   * 모든 News 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerFindAllV1$Response(params?: NewsControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NewsDto>>> {
    return newsControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 News 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerFindAllV1(params?: NewsControllerFindAllV1$Params, context?: HttpContext): Observable<Array<NewsDto>> {
    return this.newsControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NewsDto>>): Array<NewsDto> => r.body)
    );
  }

  /** Path part for operation `newsControllerCreateV1()` */
  static readonly NewsControllerCreateV1Path = '/api/v1/news';

  /**
   * News 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsControllerCreateV1$Response(params: NewsControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsDto>> {
    return newsControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * News 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsControllerCreateV1(params: NewsControllerCreateV1$Params, context?: HttpContext): Observable<NewsDto> {
    return this.newsControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsDto>): NewsDto => r.body)
    );
  }

  /** Path part for operation `newsControllerFindAdjacentV1()` */
  static readonly NewsControllerFindAdjacentV1Path = '/api/v1/news/{id}/adjacent';

  /**
   * 이전글/다음글 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerFindAdjacentV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerFindAdjacentV1$Response(params: NewsControllerFindAdjacentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjacentNewsDto>> {
    return newsControllerFindAdjacentV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 이전글/다음글 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerFindAdjacentV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerFindAdjacentV1(params: NewsControllerFindAdjacentV1$Params, context?: HttpContext): Observable<AdjacentNewsDto> {
    return this.newsControllerFindAdjacentV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdjacentNewsDto>): AdjacentNewsDto => r.body)
    );
  }

  /** Path part for operation `newsControllerFindByIdV1()` */
  static readonly NewsControllerFindByIdV1Path = '/api/v1/news/{id}';

  /**
   * News id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerFindByIdV1$Response(params: NewsControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsDto>> {
    return newsControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * News id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerFindByIdV1(params: NewsControllerFindByIdV1$Params, context?: HttpContext): Observable<NewsDto> {
    return this.newsControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsDto>): NewsDto => r.body)
    );
  }

  /** Path part for operation `newsControllerDeleteV1()` */
  static readonly NewsControllerDeleteV1Path = '/api/v1/news/{id}';

  /**
   * News 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerDeleteV1$Response(params: NewsControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return newsControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * News 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerDeleteV1(params: NewsControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.newsControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `newsControllerUpdateV1()` */
  static readonly NewsControllerUpdateV1Path = '/api/v1/news/{id}';

  /**
   * News 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsControllerUpdateV1$Response(params: NewsControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsDto>> {
    return newsControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * News 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  newsControllerUpdateV1(params: NewsControllerUpdateV1$Params, context?: HttpContext): Observable<NewsDto> {
    return this.newsControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsDto>): NewsDto => r.body)
    );
  }

  /** Path part for operation `newsControllerToggleExposedV1()` */
  static readonly NewsControllerToggleExposedV1Path = '/api/v1/news/{id}/expose';

  /**
   * 보도자료 노출/노출해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `newsControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerToggleExposedV1$Response(params: NewsControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return newsControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 보도자료 노출/노출해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `newsControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  newsControllerToggleExposedV1(params: NewsControllerToggleExposedV1$Params, context?: HttpContext): Observable<boolean> {
    return this.newsControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
